import { useState } from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import Leads from '@/pages/painel-pedidos/components/Leads';
import Pipeline from '@/pages/painel-pedidos/components/Pipeline';
import WhatsAppConversas from '@/pages/painel-pedidos/components/WhatsAppConversas';
import Calendario from '@/pages/painel-pedidos/components/Calendario';
import FunilVendas from '@/pages/painel-pedidos/components/FunilVendas';
import IaChat from '@/pages/painel-pedidos/components/IaChat';
import FilasModule from '@/pages/painel/components/FilasModule';

function useRefreshKey() {
  const [refreshKey, setRefreshKey] = useState(0);
  const onChanged = () => setRefreshKey((k) => k + 1);
  return { refreshKey, onChanged };
}

const CRM_HOME_CARDS = [
  {
    to: '/painel/crm/leads',
    label: 'Leads',
    icon: 'ri-building-4-line',
    description: 'Base de leads e empresas em prospecção.',
  },
  {
    to: '/painel/crm/pipeline',
    label: 'Pipeline',
    icon: 'ri-filter-3-line',
    description: 'Oportunidades em andamento no funil.',
  },
  {
    to: '/painel/crm/whatsapp',
    label: 'WhatsApp',
    icon: 'ri-whatsapp-line',
    description: 'Conversas e histórico de atendimento.',
  },
  {
    to: '/painel/crm/calendario',
    label: 'Calendário',
    icon: 'ri-calendar-line',
    description: 'Agenda e compromissos comerciais.',
  },
  {
    to: '/painel/crm/funil',
    label: 'Funil',
    icon: 'ri-bar-chart-2-line',
    description: 'Métricas e desempenho de vendas.',
  },
  {
    to: '/painel/crm/ia',
    label: 'IA comercial',
    icon: 'ri-sparkling-2-line',
    description: 'Assistente inteligente de vendas.',
  },
];

export function CrmHome() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {CRM_HOME_CARDS.map((c) => (
        <Link
          key={c.to}
          to={c.to}
          className="group bg-white rounded-2xl border border-gray-200 p-5 hover:border-[#E8610A]/40 transition-colors duration-150 cursor-pointer"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 text-[#E8610A] rounded-xl mb-3">
            <i className={`${c.icon} text-lg`}></i>
          </div>
          <h3 className="font-semibold text-gray-900 group-hover:text-[#E8610A] transition-colors">
            {c.label}
          </h3>
          <p className="text-sm text-gray-500 mt-1">{c.description}</p>
        </Link>
      ))}
    </div>
  );
}

export function CrmLeads() {
  const { password } = useOutletContext<{ password: string }>();
  const { refreshKey, onChanged } = useRefreshKey();
  return (
    <Leads password={password} refreshKey={refreshKey} onChanged={onChanged} />
  );
}

export function CrmPipeline() {
  const { password } = useOutletContext<{ password: string }>();
  const { refreshKey, onChanged } = useRefreshKey();
  return (
    <Pipeline
      password={password}
      refreshKey={refreshKey}
      onChanged={onChanged}
    />
  );
}

export function CrmWhatsapp() {
  const { password } = useOutletContext<{ password: string }>();
  return <WhatsAppConversas password={password} />;
}

export function CrmCalendario() {
  const { password } = useOutletContext<{ password: string }>();
  const { refreshKey, onChanged } = useRefreshKey();
  return (
    <Calendario
      password={password}
      refreshKey={refreshKey}
      onChanged={onChanged}
    />
  );
}

export function CrmFunil() {
  const { password } = useOutletContext<{ password: string }>();
  const { refreshKey, onChanged } = useRefreshKey();
  return (
    <FunilVendas
      password={password}
      refreshKey={refreshKey}
      onChanged={onChanged}
    />
  );
}

export function CrmIa() {
  const { password } = useOutletContext<{ password: string }>();
  return <IaChat password={password} />;
}

export function CrmFilas() {
  return <FilasModule />;
}